// TODO:
// Maybe we should evaluate to read the maco token
// from the cookie "de.ul.leurisProfile"
// Cookie.getJSON('de.ul.leurisProfile').user.token (js-cookie)

export const maco = (state) => state.maco



// WEBPACK FOOTER //
// ./src/store/modules/tomaner/getters.js